var jQuery=$=require('jquery');
    module.exports = {
        // props: ['hotelId'],
        components:{
          modal:require('vue-strap').modal
        },
        data:function(){
            return {
                hotel: '',
                param:'',
                roomsummary: '',
                isShow: 0,
                tagLib: [],
                guestroomnote:'',
                user:localStorage['username'],
               	addTagtype:'',
               	addTagName:'',
               	url: this.otherApiPath,
                tagshow:[],
                tags: [],
                isconfirm:false,
                rooms: [{
                    id: '',
                    hotel: '',
                    name: '标准间',
                    en: '',
                    area: '',
                    floor: '',
                    adult: '',
                    pics:[],
                    child: '',
                    bed: '',
                    smoke: 1,
                    pet: 0,
                    addbe: 1,
                    updatetime:'',
                    intro:'',
                    window: 1, // 是否有窗
                    scenery: '' // 窗外景观
                }]
            }
        },
        //计算属性
        computed: {
            facilityTag:function(){
                //var design=[];
                //console.log(this.tagLib)
               return this.tags.filter(function(x){
                  // return x.type==amenity
                //  console.log(x)
                  return x.type=="facility"
                })
            },
            cateringTag:function(){
                return this.tags.filter(function(x){
                  return x.type=='catering'
                })
            },
            appliancesTag:function(){
                return this.tags.filter(function(x){
                  return x.type=='appliances'
                })
            },
            bathroomTag:function(){
                return this.tags.filter(function(x){
                  return x.type=='bathroom'
                })
            },
            washingTag:function(){
                return this.tags.filter(function(x){
                  return x.type=='washing'
                })
            },
            othserveTag:function(){
                return this.tags.filter(function(x){
                  return x.type=='othserve'
                })
            },
            tagsId:function(){
                return this.tags.map(function(x){
                    return x.id
                })
            }
        },
        ready:function(){
           var that = this;
           this.guestroomnote = new wangEditor('#div1');
            this.guestroomnote.customConfig.menus = [
                'bold',  // 粗体
                'fontSize',  // 字号
                'italic',  // 斜体
                'underline',  // 下划线
                'strikeThrough',  // 删除线
                'foreColor',  // 文字颜色
                'backColor',  // 背景颜色
                'list',  // 列表
                'justify',  // 对齐方式
                'image',  // 插入图片
                'undo',  // 撤销
                'redo'  // 重复
            ];
            this.guestroomnote.customConfig.customUploadImg = function (files, insert) {
                // files 是 input 中选中的文件列表
                // insert 是获取图片 url 后，插入到编辑器的方法
                $.each(files, function(i, file) {
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = function(file){
                        var dataURL = reader.result;
                        var data = {
                            method: 'picture_upload',
                            token: localStorage['token'],
                            file: dataURL,
                            name: file.name
                        }
                        var jqPromise = $.post(that.baseApiPath, data);
                        Promise.resolve(jqPromise)
                        .then(function(value){
                            var value= JSON.parse(value);
                            // 上传代码返回结果之后，将图片插入到编辑器中
                            insert(value.data.file);
                        })
                    }
                });
            }
            this.guestroomnote.create();
            window.guestroomnote = this.guestroomnote;
           this.param =this.$route.params.id;
	           this.hotel = this.param;
               
               
	           if(this.param){
	            var data = {
	                method: 'room_load',
	                token: localStorage['token'],
	                hotel: this.param - 0
	            }
	            // this.$http.post('/app.php',data).then(function(value){
	            // 	console.log(value)
	            // })
	            var jqPromise = $.post(this.url, data);
	            var realPromise = Promise.resolve(jqPromise),
	                that = this;
	            realPromise.then(function(value){
	            	  var value = JSON.parse(value)
	            	  return value;
	            })
	           .then(function(value) {
	           		that.roomsummary=value.data&&value.data.roomsummary||'';
                    if(value.data&&value.data.rooms.length!=0){
                        that.rooms =value.data.rooms;
                    }else{
                        that.rooms = [{
                            id: '',
                            hotel: '',
                            name: '',
                            en: '',
                            area: '',
                            pics:[],
                            floor: '',
                            adult: '',
                            child: '',
                            bed: '',
                            smoke: 0,
                            pet: 0,
                            addbe: 0,
                            updatetime: ''
                        }];
                    }
	                return value;
	            })
	            .then(function(value) {
	              	that.tags=value.data&&value.data.tags
	               // $('.roomsummary .panel-body').html(value.data.roomsummary);
	               // console.log(that.roomsummary)
                   that.guestroomnote.txt.html('');
                that.guestroomnote.txt.append(that.roomsummary);
                    
                    if($('.namezw').val()!='') {
                        $('.namezw').attr('readonly',true);
                    }
	                return value;
	            })
	            // .then(function(value) {
	            //       // that.specialnote = new Simditor({
             //       //    textarea: $('.specialnote'),
             //       //     toolbar:['title','bold','italic','underline','fontScale','color','ol','ul','blockquote','code','link','image','hr','alignment']
             //       //    // toolbar:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
             //       //  });
             //      // that.guestroomnote.setValue(value.data.roomsummary)

	            //     return value
	            // }).then(function(value){
	            //     // for(var item in that.rooms){
	            //     //   //  $('.specialintro .panel-body')[item].innerHTML=that.rooms[item].intro
	            //     //   // that.specialnote[item].setValue(item)
	            //     // }
	            // })
	         }

            // 增加一个全局param变量
            _flag_param = this.param;
            
            // if(this.param) {

            //     var that = this;
            //     var p1 = new Promise(function(resolve, reject) {
            //         resolve('success')
            //     })
            //     p1.then(function(value) {
            //         that.rooms.push({
            //             id: '',
            //             hotel: '',
            //             name: '',
            //             en: '',
            //             area: '',
            //             floor: '',
            //             adult: '',
            //             child: '',
            //             bed: '',
            //             smoke: 0,
            //             pet: 0,
            //             addbe: 0,
            //             intro:'',
            //             updatetime: ''
            //         });
            //         return value;
            //     })
            //     // .then(function(value) {
            //     //     // $('.specialnote').summernote({
            //     //     //     height: 100
            //     //     // });
            //     //     return value
            //     // })
            //     .then(function(value) {
            //         that.isShow = that.rooms.length - 1
            //     })
            //     this.isconfirm=true;

            // } else {
                
            // }

        },
        attached:function(){
            var that=this;
            $('.container-fluid').on('change','input',function(){
                that.isconfirm=true;
                   });
            $('.container-fluid').on('change','textarea',function(){
                that.isconfirm=true;
            });
        },
        methods: {
            isPlus:function(num){
                if (num<0) {
                    alert('儿童数最小为0')
                }
            },
            uploadhandle:function(e){
                var that=this;
                 var fileList = e.target.files;
                //console.log(files)
                var reader=new FileReader();
              //  console.log(that.num)
                if(fileList[0]&& fileList[0].type&& fileList[0].type.match('image.*')){
                    reader.readAsDataURL(fileList[0]);
                  }
                reader.onload = (function(file){
                    return function(e){
                       // console.log(that.rooms[that.isShow])
                        if(that.rooms[that.isShow].pics==null){
                            that.rooms[that.isShow].pics=[];
                        }
                      var dataURL = reader.result;
                         var data = {
                                method: 'picture_upload',
                                token: localStorage['token'],
                                file: dataURL,
                                name:fileList[0].name
                            }
                            var jqPromise = $.post(that.baseApiPath, data);
                            var realPromise = Promise.resolve(jqPromise);
                            realPromise.then(function(value){
                                var value= JSON.parse(value);
                                 that.rooms[that.isShow].pics.push(value.data.file);
                            }) 
                    }
                // console.log(reader.result)
                // console.log(dataURL)

                //  var output = document.getElementById('output');
                // for(var item in input.files){

                  // }
                 //  var str = "<img data-id='123145' src='"+dataURL+"'>";
                 //  $('#output').append(str);
                 // console.log(str)
                 //  output.src = dataURL;
                })(fileList[0])
            },
            delpic:function(num){
                this.rooms[this.isShow].pics.splice(num, 1);
                this.isconfirm=true;
            },
            addroom: function() {
                var that = this;
                var p1 = new Promise(function(resolve, reject) {
                    resolve('success')
                })
                p1.then(function(value) {
                    that.rooms.push({
                        id: '',
                        hotel: '',
                        name: '',
                        en: '',
                        area: '',
                        floor: '',
                        adult: '',
                        child: '',
                        bed: '',
                        smoke: 0,
                        pet: 0,
                        addbe: 0,
                        intro:'',
                        updatetime: ''
                    });
                    return value;
                })
                // .then(function(value) {
                //     // $('.specialnote').summernote({
                //     //     height: 100
                //     // });
                //     return value
                // })
                .then(function(value) {
                    that.isShow = that.rooms.length - 1
                })
                this.isconfirm=true;
            },
            changeroom: function(num) {
                this.isShow = num
            },
            delroom: function(num,item) {
                if (item['id']===undefined) {
                       if (num == this.rooms.length - 1) {
                            this.isShow = this.rooms.length - 2
                        }
                        this.rooms.splice(num, 1)
                        this.isconfirm=true;
                        return
                }
                var delroomPromise = $.post(this.url, {
                    method: 'room_candel',
                    token: localStorage['token'],
                    id:item['id']
                });
                // console.log(item);
                // console.log(this.rooms);
                // return false;
                var delPromise = Promise.resolve(delroomPromise),_this=this;
                delPromise.then(function(value){
                    var value = JSON.parse(value);
                    if (value.data) {
                         if (num == _this.rooms.length - 1) {
                            _this.isShow = _this.rooms.length - 2
                        }
                        _this.rooms.splice(num, 1)
                        _this.isconfirm=true;
                    }else{
                        alert(value.message);
                        // alert(value);
                        return false;
                    }
                })
               
            },
            showTags: function(type,tags) {
                //design
                this.addTagtype=type
                var tagPromise = $.post(this.url, {
                    method: 'tag_types',
                    token: localStorage['token'],
                    types: type,
                    tags: 1
                });
                var tagsPromise = Promise.resolve(tagPromise),
                    that = this;
                tagsPromise.then(function(value) {
                    // console.log(value)
                    var value = JSON.parse(value);
                    that.tagLib = value.data&&value.data[0].tags;
                    //console.log(that.tagLib)
                })
                 .then(function(value){
                  //  console.log(tags)
                  that.tagshow=[];
                  that.tagshow.length=that.tagLib.length;
                for(j in that.tagLib){
                    for(i in tags){
                        if(that.tagLib[j].id==tags[i].id){
                            that.tagshow[j]=1;
                          //  console.log(that.tagLib[j])
                        }
                    }
                }
               // console.log(that.tagshow)
                })
            },
            addTohotel:function(num){
                if(this.tags.indexOf(this.tagLib[num])==-1){
                    this.tags.push(this.tagLib[num])
                }   
                this.isconfirm=true;                        
            },
            addTag:function(){
                var promise=$.post(this.url,{
                    method:'tag_create',
                    token:localStorage['token'],
                    type:this.addTagtype,
                    name:this.addTagName
                })
                var addtagPromise=Promise.resolve(promise),
                that=this;
                addtagPromise.then(function(value){
                    var value=JSON.parse(value);
                    if(value.code==0){
                        that.tagLib.push(value.data);
                        that.rooms[that.isShow].tags.push(value.data)
                       // console.log(that.tags)
                    }else{
                        alert(value.message)
                    }
                    return value
                })
                this.isconfirm=true;
            },
            removefacility:function(n){
                var n=n,that=this;
                this.tags=this.tags.filter(function(x){
                    return  x!=that.facilityTag[n];
                })
                this.isconfirm=true;
            },
            removecater:function(n){
                var n=n,that=this;
                this.tags=this.tags.filter(function(x){
                    return  x!=that.cateringTag[n];
                })
                this.isconfirm=true;
            },
            removeappliances:function(n){
                var n=n,that=this;
                this.tags=this.tags.filter(function(x){
                    return  x!=that.appliancesTag[n];
                })
                this.isconfirm=true;
            },
            removebathroom:function(n){
                var n=n,that=this;
                this.tags=this.tags.filter(function(x){
                    return  x!=that.bathroomTag[n];
                })
                this.isconfirm=true;
            },
            removewashing:function(n){
                var n=n,that=this;
                this.tags=this.tags.filter(function(x){
                    return  x!=that.washingTag[n];
                })
                this.isconfirm=true;
            },
            removeothserve:function(n){
                var n=n,that=this;
                this.tags=this.tags.filter(function(x){
                    return  x!=that.othserveTag[n];
                })
                this.isconfirm=true;
            },
            roomSubmit: function() {
                var passed=this.rooms.some(function(x){
                    return x.name==''||undefined||null;
                })
                if(passed){
                    alert('请确保所有房间都具有房间名')
                    return;
                }
                 var nopic=this.rooms.some(function(x){
                    if(x.pics&&x.pics.length==0){
                        return true;
                    }
                    return x.pics==null||''||undefined;
                })
                if(nopic){
                    alert('请确保所有房间都具有图片')
                    return;
                }
                var roomsver=this.rooms;
                var valid=true;
                for(var item in roomsver){
                    //console.log(item)
                    if(roomsver[item].tags){
                   roomsver[item].tags=roomsver[item].tags.map(function(x){
                    return x.id
                    })
               }
                   // console.log(roomsver[item].tags)
                   // roomsver[item].intro=$('.specialintro .panel-body')[item].innerHTML
                }
                // console.log(this.guestroomnote)
                var data = {
                    method: 'room_save',
                    token: localStorage['token'],
                    hotel: this.hotel,
                    tags:this.tagsId,
                    roomsummary: this.guestroomnote.txt.html(),
                    rooms: roomsver
                };
                var jqPromise = $.post(this.url, data);
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value) {
                    var value = JSON.parse(value);
                    if (value.code == 0) {
                       // window.location.href = 'facilities.html?id=' + that.param;
                        that.isconfirm=false;
                        that.roomsummary=that.guestroomnote.txt.html()
                        that.$route.router.go({name:'facilities',params:{id:that.param}})
                    } else {
                        alert(value.message)
                    }
                })
            }
        },

        route:{
            activate:function(transtition){
                window.scrollTo(0,0);
                transtition.next()
            },
            canDeactivate:function(transition){
                if(this.isconfirm||this.roomsummary!=this.guestroomnote.txt.html()){
                    if(confirm('还未保存，确定退出？')){
                        transition.next()
                    }else{
                        transition.abort()
                    }
                }else{
                    transition.next()
                }
                
            },
            data: function(transtition) {
            	// window.scrollTo(0,0);
            	 this.param =this.$route.params.id;
	            this.hotel = this.param;
                this.$dispatch('pageinfo','客房信息');
	             if(this.param){
	            var data = {
	                method: 'room_load',
	                token: localStorage['token'],
	                hotel: this.param - 0
	            }
	            // this.$http.post('/app.php',data).then(function(value){
	            // 	console.log(value)
	            // })
	            var jqPromise = $.post(this.url, data);
	            var realPromise = Promise.resolve(jqPromise),
	                that = this;
	            realPromise.then(function(value){
	            	  var value = JSON.parse(value)
	            	  return value;
	            })
	           .then(function(value) {
	           		that.roomsummary=value.data&&value.data.roomsummary||'';
                    if(value.data.rooms[0]){
                         that.rooms = value.data&&value.data.rooms || [{
                        id: '',
                        hotel: '',
                        name: '',
                        en: '',
                        area: '',
                        floor: '',
                        adult: '',
                        child: '',
                        bed: '',
                        smoke: 0,
                        tags: [],
                        pet: 0,
                        addbe: 0,
                        updatetime: ''
                    }];
                }else{
                      that.rooms =[{
                        id: '',
                        hotel: '',
                        name: '',
                        en: '',
                        area: '',
                        floor: '',
                        adult: '',
                        child: '',
                        bed: '',
                        smoke: 0,
                        tags: [],
                        pet: 0,
                        addbe: 0,
                        updatetime: ''
                    }];
                }
	               
	                return value;
	            })
	            .then(function(value) {
                    that.tags=value.data&&value.data.tags
                    // console.log(that.tags)
	               // $('.roomsummary .panel-body').html(value.data.roomsummary);
	               // console.log(that.roomsummary)
                      that.guestroomnote.txt.html('');
                        that.guestroomnote.txt.append(that.roomsummary);
                    if($('.namezw').val()!='') {
                        $('.namezw').attr('readonly',true);
                    }
	                return value;
	            })
	            // .then(function(value) {
	            //       // that.specialnote = new Simditor({
             //       //    textarea: $('.specialnote'),
             //       //     toolbar:['title','bold','italic','underline','fontScale','color','ol','ul','blockquote','code','link','image','hr','alignment']
             //       //    // toolbar:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
             //       //  });
             //      // that.guestroomnote.setValue(value.data.roomsummary)

	            //     return value
	            // }).then(function(value){
	            //     // for(var item in that.rooms){
	            //     //   //  $('.specialintro .panel-body')[item].innerHTML=that.rooms[item].intro
	            //     //   // that.specialnote[item].setValue(item)
	            //     // }
	            // })
	         }
	         // else{
	        //      // $('.specialnote').summernote({
	        //      //        height: 100
	        //      //    });
	        // }
            
            transtition.next();
        },
        }
    }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/guestroom.vue
// module id = 88
// module chunks = 0